import { type FC } from "react";
import { MenuItem, TextField } from "@mui/material";

export interface FilterSelectOption {
  value: string;
  label: string;
}

interface Props {
  label: string;
  value: string;
  options: FilterSelectOption[];
  emptyLabel?: string;
  onChange: (value: string) => void;
}

const FilterSelectField: FC<Props> = ({ label, value, options, emptyLabel = "Wszystkie", onChange }) => (
  <TextField select size="small" label={label} value={value} onChange={(event) => onChange(event.target.value)}>
    <MenuItem value="">{emptyLabel}</MenuItem>
    {options.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
);

export default FilterSelectField;
